(ns livefeed.websocket
  (:require [cljs.core.async :refer [<! >! put! chan] :refer-macros [go]]
            [clojure.string :as str]
            [reagent.core :as reagent]
            [livefeed.properties :as properties]
            [livefeed.analytics :as analytics]
            [livefeed.feed :as feed]
            [taoensso.sente :as sente]
            [livefeed.state :as state]
            [taoensso.trove :refer [set-log-fn!]]
            [taoensso.trove.console :refer [get-log-fn]]))

;; set log level to :warn
(set-log-fn! (get-log-fn {:min-level :warn}))

(defonce websocket-client (atom nil))

(defonce router_ (atom nil))

(defonce connected? (reagent/atom false))

(defn- handle-connection-state-change [connection-open?]
  (when-let [event-handler (:event-handler @websocket-client)]
    (event-handler :chat/flow-control {:clear-to-send connection-open?
                                       :reason        :connection-closed})
    (reset! connected? connection-open?)))

(defmulti -event-msg-handler
  "Multimethod to handle Sente `event-msg`s"
  :id)

(defn event-msg-handler
  "Wraps `-event-msg-handler` with logging, error catching, etc."
  [{:as ev-msg :keys [id ?data event]}]
  (-event-msg-handler ev-msg))

(defmethod -event-msg-handler
  :default
  [{:as ev-msg :keys [event]}]
  (js/console.log (str "unhandled event: " (str event))))

(defmethod -event-msg-handler :chsk/state
  [{:keys [?data]}]
  (let [[_ new-state-map] ?data
        send-fn (:send-fn @websocket-client)
        {:keys [first-open? open?]} new-state-map]
    (when first-open?
      (send-fn [:chat/connect]))
    (handle-connection-state-change open?)
    (when open?
      (when-not first-open?
        (send-fn [:chat/state-check])
        (feed/reset-feed!)
        (let [chat-id (properties/get-property :chatId)]
          (when @state/best-view-enabled? (feed/load-initial-messages chat-id true))
          (feed/load-initial-messages chat-id false))))))

(defmethod -event-msg-handler :chsk/recv
  [{:as ev-msg :keys [?data]}]
  (let [[id data] ?data]
    (when-let [event-handler (:event-handler @websocket-client)]
      (event-handler id data))))

(defmethod -event-msg-handler :chsk/handshake
  [_])

(defn stop-router! []
  (when-let [stop-f @router_]
    (stop-f)
    (reset! router_ nil)))

(defn reconnect! []
  (when-let [chsk (:chsk @websocket-client)]
    (sente/chsk-reconnect! chsk)))

(defn disconnect! []
  (when-let [chsk (:chsk @websocket-client)]
    (sente/chsk-disconnect! chsk)
    (reset! websocket-client nil)
    (stop-router!)
    (reset! connected? false)))

(defn send-message [message]
  (when-let [send-fn (:send-fn @websocket-client)]
    (when-not (str/blank? message)
      (let [quoted-message-id (:comment-id @feed/quoted-message)]
        (analytics/track-event "comment" "sent")
        (reset! feed/quoted-message nil)
        (boolean (send-fn [:chat/new-message (cond-> {:content message}
                                               quoted-message-id (assoc :quote-id quoted-message-id))]))))))

(defn send-message-reaction [message-id reaction-type]
  (when-let [send-fn (:send-fn @websocket-client)]
    (send-fn [:chat/comment-reaction {:comment-id message-id :reaction-type reaction-type}])))

(defn send-feed-reaction [reaction-type]
  (when-let [send-fn (:send-fn @websocket-client)]
    (send-fn [:chat/chat-reaction {:reaction-type reaction-type}])))

(defn like-message [message-id]
  (send-message-reaction message-id "like"))

(defn unlike-message [message-id]
  (send-message-reaction message-id "remove-like"))

(defn send-poll-answer [poll-id answer]
  (when-let [send-fn (:send-fn @websocket-client)]
    (send-fn [:chat/poll-entry {:poll-id     poll-id
                                :poll-answer answer}])))

(defn init [event-handler]
  (let [props (properties/get-property :websocket-api)
        {path :path
         host :host
         protocol :protocol} props
        client (sente/make-channel-socket-client! path
                                                  nil
                                                  {:type :ws
                                                   :packer :edn
                                                   :wrap-recv-evs? true
                                                   :host host
                                                   :params {:topicId (properties/get-property :chatId)}
                                                   :protocol protocol})]
    (reset! websocket-client
            (assoc client :event-handler event-handler))
    (stop-router!)
    (reset! router_
            (sente/start-client-chsk-router! (:ch-recv client) event-msg-handler))))

(defn init-or-reconnect! [event-handler]
  (when (and (nil? @state/label)
             (not @state/locked?))
    (if @websocket-client
      (reconnect!)
      (init event-handler))))
